import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import { Table, Icon } from "@zillow/constellation";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import { getRemainingMonthlyPayment } from "./DTICalculator.utils.esm.js";
const circleSvg = /* @__PURE__ */ jsx("svg", { viewBox: "0 0 10 10", children: /* @__PURE__ */ jsx("circle", { cx: "5", cy: "5", r: "4" }) });
const DTICostBreakdownTable = ({
  debtsOut,
  monthlyIncome,
  mortgagePayment
}) => /* @__PURE__ */ jsx(Table, { appearance: "barebones", "aria-label": "Debt to income cost breakdown table", size: "lg", alignments: ["left", "right"], children: /* @__PURE__ */ jsxs(Table.Body, { children: [
  /* @__PURE__ */ jsxs(Table.Row, { children: [
    /* @__PURE__ */ jsxs(Table.Cell, { style: {
      padding: "8px 0 0"
    }, children: [
      /* @__PURE__ */ jsx(Icon, { fontColor: "orange500", children: circleSvg }),
      " Total monthly debts"
    ] }),
    /* @__PURE__ */ jsx(Table.Cell, { style: {
      padding: "8px 0 0"
    }, children: getWholeDollars(debtsOut) })
  ] }),
  /* @__PURE__ */ jsxs(Table.Row, { children: [
    /* @__PURE__ */ jsxs(Table.Cell, { style: {
      padding: "8px 0 0"
    }, children: [
      /* @__PURE__ */ jsx(Icon, { fontColor: "blue600", children: circleSvg }),
      " Mortgage payment"
    ] }),
    /* @__PURE__ */ jsx(Table.Cell, { style: {
      padding: "8px 0 0"
    }, children: getWholeDollars(mortgagePayment) })
  ] }),
  /* @__PURE__ */ jsxs(Table.Row, { children: [
    /* @__PURE__ */ jsxs(Table.Cell, { style: {
      padding: "8px 0 0"
    }, children: [
      /* @__PURE__ */ jsx(Icon, { fontColor: "brand", children: circleSvg }),
      " Remaining mo. income"
    ] }),
    /* @__PURE__ */ jsx(Table.Cell, { style: {
      padding: "8px 0 0"
    }, children: getWholeDollars(getRemainingMonthlyPayment(monthlyIncome, debtsOut, mortgagePayment)) })
  ] })
] }) });
DTICostBreakdownTable.propTypes = {
  debtsOut: PropTypes.number,
  monthlyIncome: PropTypes.number,
  mortgagePayment: PropTypes.number
};
export {
  DTICostBreakdownTable as default
};
